import { useLightMode } from '@/hooks/useLightMode'

import { Notification } from '@/graphql/appsync-notifications'

import { getNotificationToastTokens } from '../styles/tokens'
import { NotificationDescription } from './NotificationDescription'
import { NotificationSubtitle } from './NotificationSubtitle'
import { NotificationTitle } from './NotificationTitle'
import { NotificationToastShell } from './NotificationToastShell'

export const IncidentNotification = ({
  notification,
  onCancel,
}: {
  notification: Notification
  onCancel?: (incidentTimeStamp: string) => void
}) => {
  const tokens = getNotificationToastTokens(useLightMode())
  return (
    <NotificationToastShell
      accentColor={tokens.danger}
      notificationTimestamp={notification?.notificationTimestamp}
      onCancel={onCancel}
    >
      <NotificationTitle
        subTitle={notification?.incidentName}
        title={notification?.incidentDisplayId}
      />
      <NotificationSubtitle
        facilityShortName={notification?.facilityShortName}
        sourceName={notification?.incidentSourceName}
        timestamp={notification?.notificationTimestamp}
      />
      <NotificationDescription desc={notification?.incidentDescription} />
    </NotificationToastShell>
  )
}
